<template>
  <v-list-item>
    <v-snackbar
      v-model="alertError"
      bottom
      color="error"
      icon="mdi-alert"
      border="left"
      elevation="2"
      class="mb-2"
      timeout="6000"
    >
      Errore durante la modifica della contabile.
    </v-snackbar>
    <v-dialog v-model="dialogConfermaSaldato" max-width="500">
      <v-card>
        <v-card-title class="headline">Conferma</v-card-title>
        <v-card-text
          >Sei sicuro di voler cambiare lo stato di saldato?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confermaSaldato">Sì</v-btn>
          <v-btn color="red darken-1" text @click="annullaSaldato">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-list-item-content @click="$refs.modifica_contabile.open()">
      <v-list-item-title>{{ cliente.nome }}</v-list-item-title>
      <v-list-item-subtitle>{{ dataFormatted }}</v-list-item-subtitle>
      <v-list-item-subtitle v-if="contabile.ddt"
        >DDT # {{ contabile.ddt }}</v-list-item-subtitle
      >
      <v-list-item-subtitle v-if="contabile.id_ordine">
        <span
          >Ordine
          <ContabileOrdineRef
            readonly
            :id_ordine="contabile.id_ordine"
            ref="contabileOrdineRef" /></span
      ></v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action-text>
      <span
        class="pa-1"
        :class="[
          contabile.tipo == 1
            ? contabile.verde
              ? 'green--text'
              : 'blue--text'
            : contabile.tipo == 2
            ? 'text-no-wrap green white--text'
            : 'purple--text',
          saldato ? 'text-decoration-line-through' : '',
        ]"
      >
        € {{ contabile.importo.toFixed(2) }}
      </span>
    </v-list-item-action-text>
    <v-list-item-action>
      <v-checkbox
        v-model="saldato"
        readonly
        dense
        hide-details
        @click="toggle_saldato(false)"
      ></v-checkbox>
    </v-list-item-action>
    <modifica_contabile_mobile
      ref="modifica_contabile"
      :contabile="contabile"
      @update-contabile="$emit('new_insert')"
    />
  </v-list-item>
</template>

<script>
import contabile_element_mixin from "../mixin/contabile_element_mixin";
import modifica_contabile_mobile from "./modifica_contabile_mobile.vue";
import ContabileOrdineRef from "../desktop/contabile_ordine_ref.vue";
export default {
  components: {
    modifica_contabile_mobile,
    ContabileOrdineRef,
  },
  mixins: [contabile_element_mixin],
};
</script>